// Mobile footer accordion: the column headings open and close their link lists. From tablet up the lists are
// always shown by CSS and the headings don't respond.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.pl-footer__toggle');
  if (!toggle || matchMedia('(min-width: 750px)').matches) return;
  const open = toggle.getAttribute('aria-expanded') !== 'true';
  document.querySelectorAll('.pl-footer__toggle').forEach((other) => other.setAttribute('aria-expanded', 'false'));
  toggle.setAttribute('aria-expanded', String(open));
});
